import React from "react";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Badge } from "react-bootstrap";
import { StandardTableComponent } from "../../basics/table";
import FormattedMessageString from "../../basics/FormattedMessageString";
import Module from "../../../models/module/Module";
import EventWaitingListEntry from "../../../models/event/EventWaitingListEntry";

/**
 * Waiting list of an event (or one period): position, attendee, e-mail, date of subscription and status
 */
class WaitingListOverviewTableComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: this.props.rows,
            settings: Module.getSettings()
        };
    }

    componentDidMount() {
        if (!this.state.settings.use_waiting_list) {
            this.props.history.push('/module/events/' + Module.get().id + '/overview');
        }
    }

    columns = () => {
        let columns = [];

        if (this.state.settings.use_periods && !this.props.match.params.period) {
            columns.push({
                dataField: 'period_title',
                text: <FormattedMessageString id="CMS.Event.waiting_list.overview.table.period" />,
                sort: true
            });
        }

        columns.push({
            dataField: 'position',
            text: <FormattedMessageString id="CMS.Event.waiting_list.overview.table.position" />,
            sort: true,
            headerStyle: () => ({ width: '8%' })
        }, {
            dataField: 'attendee',
            text: <FormattedMessageString id="CMS.Event.waiting_list.overview.table.attendee" />,
            sort: true,
            isDummyField: true,
            formatter: (cellContent, row) => row.attendee ? row.attendee.name : '-'
        }, {
            dataField: 'client',
            text: <FormattedMessageString id="CMS.Event.waiting_list.overview.table.client" />,
            sort: true,
            isDummyField: true,
            formatter: (cellContent, row) => row.client ? row.client.name : '-'
        }, {
            dataField: 'email',
            text: <FormattedMessageString id="CMS.Event.waiting_list.overview.table.email" />,
            sort: true
        }, {
            dataField: 'created_at',
            text: <FormattedMessageString id="CMS.Event.waiting_list.overview.table.created_at" />,
            sort: true,
            sortFunc: (a, b, order) => order === 'asc' ? a - b : b - a,
            formatter: (cellContent, row) => row.created_at ? row.created_at.format('DD/MM/YYYY HH:mm') : '-'
        }, {
            dataField: 'status',
            text: <FormattedMessageString id="CMS.Event.waiting_list.overview.table.status" />,
            sort: true,
            formatter: (cellContent, row) => (
                <>
                    <FormattedMessage id={'CMS.Event.waiting_list.status.' + row.status}>
                        {value => <Badge pill variant={row.statusVariant()}>{value}</Badge>}
                    </FormattedMessage>

                    {row.status === EventWaitingListEntry.STATUS_AVAILABLE && row.expires_at && (
                        <FormattedMessage id="CMS.Event.waiting_list.overview.table.expires_at" values={{ date: row.expires_at.format('DD/MM/YYYY HH:mm') }}>
                            {value => <p className="small mb-0">{value}</p>}
                        </FormattedMessage>
                    )}
                    {row.status === EventWaitingListEntry.STATUS_REGISTERED && row.registered_at && (
                        <FormattedMessage id="CMS.Event.waiting_list.overview.table.registered_at" values={{ date: row.registered_at.format('DD/MM/YYYY HH:mm') }}>
                            {value => <p className="small mb-0">{value}</p>}
                        </FormattedMessage>
                    )}
                </>
            )
        });

        return columns;
    }

    render() {
        return (
            <div className="custom-data-table event">
                <StandardTableComponent keyField="id" data={this.state.rows} columns={this.columns()} search={true}
                    title={this.props.title_id} type={this.props.type}
                    subRows={false}
                    sort={{ dataField: 'position', order: 'asc' }}
                />
            </div>
        );
    }
}

export default withRouter(WaitingListOverviewTableComponent);
